/* @flow */

import keymirror from 'keymirror';

const SidePanelConstants = keymirror({
  SIDEPANEL_SET_SEARCH_RESULTS: null,
  SIDEPANEL_SET_SEARCH_RESULTS_NONE: null,
  SIDEPANEL_UPDATE_SEARCH_PAGE: null,
  SIDEPANEL_CLEAR_SEARCH: null,
  SIDEPANEL_TOGGLE_COLLAPSED: null,
  SIDEPANEL_LOADING_START: null,
  SIDEPANEL_LOADING_END: null,
  SIDEPANEL_SET_ACTIVEID: null,
});

export { SidePanelConstants };
